import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BoardServiceService } from '../../services/board-service.service';
import { catchError, finalize, first } from 'rxjs/operators';
import { FilesServiceService } from '../../services/files-service.service';
import { ModalFilesComponent } from 'src/app/shared/modal-files/modal-files.component';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin, of } from 'rxjs';
import { UtilsService } from 'src/app/core/service/utils.service';
import { UserServiceService } from 'src/app/pages/users/services/user-service.service';
import { ActivatedRoute } from '@angular/router';
import { BoardMainScreenService } from '../board-main-screen/board-main-screen.service';
import { isArray, reverse } from 'lodash';

@Component({
  selector: 'app-task-coments',
  templateUrl: './task-coments.component.html',
  styleUrls: ['./task-coments.component.scss']
})
export class TaskComentsComponent implements OnInit {
  @Input() taskId: number = 0;
  @Input() projectId: number | null = null;
  @Input() modalV: boolean = false;

  coments: any = [];
  loading: boolean = false;
  showError: boolean = false;

  submitted: boolean = false;
  chatForm!: FormGroup;
  moreThan40: boolean = false;

  mentions: any = [];
  pageSize: number = 40;

  //Modal Files
  showModal = false;
  showModalRequestFiles = false;
  deleteFiles: any = [];
  @ViewChild('modal', { static: true }) modal: ModalFilesComponent | null = null;

  constructor(
    public sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private fileService: FilesServiceService,
    private boardService: BoardServiceService,
    public translateService: TranslateService,
    public boardMainScreen: BoardMainScreenService,
    protected utilSrv: UtilsService,
    private route: ActivatedRoute,
  ) {
    // this.projectId = this.route.snapshot.params.projectId;
  }

  ngOnInit(): void {
    this.setChatForm();
    this.loadData();
  }

  setChatForm() {
    this.chatForm = this.fb.group({
      taskId: [this.taskId],
      authorId: [this.taskId],
      message: [''],
      uploadFiles: [[]],
      files: [[]],
    });
  }

  get formChat() { return this.chatForm.controls; }

  loadData() {
    this.loading = true;
    if (this.taskId != null && this.taskId != 0) {
      this.boardService.getComments(this.taskId, this.pageSize)
        .pipe(first())
        .subscribe((response) => {
          if (response.data && isArray(response.data)) {
            this.coments = [];
            const data = reverse(response.data);
            this.coments = data.map((response: any) => ({
              ...response,
              photo: response.author?.photo == null ? '../../../../assets/images/user-avatar.jpg' : response.author?.photo.url
            }));

            if (this.moreThan40 == true) {
              this.moreThan40 = false;
              this.pageSize = 40;
            } else if (response.metadata.count >= 40 && this.moreThan40 == false) {
              //warn about being more than 40 comments
              this.moreThan40 = true;
            }
          }
          this.loadMentions();
          this.loading = false;
        }, error => {
          this.loading = false;
          this.utilSrv.toast(`${this.translateService.instant('BOARD.COMMENT.ERRORGET')}: ${error}`, 'error', false);
        });
    }
  }

  loadMentions() {
    this.boardService.getMentions(this.projectId).pipe(first()).subscribe((response) => {
      if (response.data.length > 0) {
        this.mentions = [];
        response.data.map((object: any) => {
          this.mentions.push({ ...object, name: object.firstName.concat(' ' + object.lastName) })
        })
      }
    }, error => {
      this.utilSrv.toast(`${this.translateService.instant('BOARD.COMMENT.ERRORMENTION')}: ${error}`, 'error', false);
    });
  }

  /*FILES */
  showModalFiles() {
    this.showModalRequestFiles = true;
    this.modal?.open(this.formChat.files.value);
  }

  saveNeedFiles($event: any) {
    if ($event) {
      if (this.showModalRequestFiles) {
        this.chatForm.patchValue({ files: $event.form });
        this.chatForm.patchValue({ uploadFiles: $event.upload });

        if ($event.delete.length > 0) $event.delete.forEach((f: any) => this.deleteFiles.push(f));
      }
    }
    //this.showModal = false;
    this.showModalRequestFiles = false;
  }

  mentionSelect(event: any) {
    return `@${event.userId}_${event.firstName.split(" ")[0]}_${event.lastName.split(" ")[0]}`;
  }

  addComent(): void {
    if (this.formChat.uploadFiles.value.length == 0 && this.formChat.message.value == '') {
      this.showError = true;
      return;
    } else {
      this.showError = false;
    }

    this.submitted = true;

    this.loading = true;
    let data = {
      message: this.formChat.message.value,
      taskId: Number(this.formChat.taskId.value),
      authorId: Number(this.formChat.authorId.value),
    }
    this.boardService.createComments(this.taskId, data).pipe(first()).subscribe((response) => {

      let promise = [];
      if (this.formChat.uploadFiles.value.length > 0) {
        promise = this.formChat.uploadFiles.value.map((file: File) => this.fileService.uploadCommmentFile(file, response.data[0].id));
      }

      if (this.formChat.uploadFiles.value.length == 0) {
        this.setChatForm();
        this.submitted = false;
        this.loadData();
        this.boardMainScreen.reloadCard.next(this.taskId);
      } else {
        forkJoin(promise)
          .pipe(
            first(),
            finalize(() => this.loading = false),
            catchError(error => {
              console.error('Files', error);
              this.loading = false
              this.utilSrv.toast(`${this.translateService.instant('FILES.ERRORSAVE')}: ${error}`, 'error', false);
              return of(false);
            })
          ).subscribe((results) => {
            if (results) {
              this.setChatForm();
              this.submitted = false;
              this.loadData();
              this.boardMainScreen.reloadCard.next(this.taskId);
            }
          });

      }
    }, (error: any) => {
      this.loading = false
      console.error('Create Comment', error);
      this.errorPopUp();
    });
  }

  preview(file: any) {
    //window.open(file);
    window.open(`${file.url}?preview=true`, '_blank')
    //window.open(URL.createObjectURL(file), '_blank')
  }

  deleteComent(event: any) {
    this.loading = true;
    this.boardService.deleteComments(this.taskId, event.id).pipe(first()).subscribe(() => {
      const index = this.coments.findIndex((item: { id: number; }) => item.id === event.id);
      this.coments.splice(index, 1);
      this.loading = false;
    }, error => {
      console.error('Delete Comment', error);
      this.utilSrv.toast(`${this.translateService.instant('BOARD.COMMENT.ERRORDELETE')}: ${error}`, 'error', false);
    });
  }

  /*POP UPS */
  successPopUp() {
    this.utilSrv.notify('SETTINGS.CREATED', 'success');
  }

  errorPopUp() {
    this.utilSrv.notify('SETTINGS.ERROR', 'error');
  }
}
